import { Component, Input, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'fip-form',
  templateUrl: './form.component.html',
  styleUrls: ['./form.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class FormComponent {
  @Input() formType: 'daterange-picker' | 'input' | 'submit' | 'slide' =
    'input';
}
